const formatCurrencyByLocale = (price, currency) => (price ? new Intl.NumberFormat(navigator.language, {
    style: 'currency',
    currency,
}).format(price) : '');
export default formatCurrencyByLocale;
//# sourceMappingURL=formatCurrencyByLocale.js.map